import { Injectable, inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { GrantService } from '@core/services';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class GrantSelectionGuard {
  private router = inject(Router);
  private grantService = inject(GrantService);

  canActivate(): Observable<boolean | UrlTree> | boolean | UrlTree {
    return this.grantService
      .userGrantSelected()
      .pipe(
        map((grantSelected) =>
          grantSelected ? true : this.router.parseUrl('/auth/select-grant'),
        ),
      );
  }
}
